import Loader from './Loader'
export default Loader



// WEBPACK FOOTER //
// ./src/components/util/Loader/index.js